import React from 'react';
import { useSelector } from 'react-redux';
import DocumentsModern from 'src/components/Documents/DocumentsModern';
import LoadState from 'src/components/LoadState/LoadState';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';

interface Contact {
  id: string;
  firstname: string;
  lastname: string;
}

interface ContactDocumentsProps {
  contact: Contact;
  documents: any[];
  loadingDocs: boolean;
  isSaving: boolean;
  saveDocument: (
    document: DocumentFormData,
    entityId: string,
    userId: string
  ) => Promise<void>;
  deleteDocument: (documentId: string) => Promise<boolean>;
}

const ContactDocuments = ({
  contact,
  documents,
  loadingDocs,
  isSaving,
  saveDocument,
  deleteDocument,
}: ContactDocumentsProps) => {
  const user: any = useSelector(selectAuthenticatedUser);

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, contact.id, user.id);
  };

  const onDeleteDocument = async (document: any): Promise<void> => {
    await deleteDocument(document.id);
  };

  return (
    <LoadState isLoading={loadingDocs}>
      <DocumentsModern
        documents={documents}
        user={user}
        labelName="Manuals & Documents"
        saving={isSaving}
        onSave={onSave}
        onDeleteDocument={onDeleteDocument}
        from="Contact"
      />
    </LoadState>
  );
};

export default ContactDocuments;
